// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .recaptcha-response {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestion/recaptcha/recaptcha.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;AAAR","sourcesContent":[":host {\n    .recaptcha-response {\n        display: inline-block;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
